export default __webpack_public_path__ + "static/media/candy_shop.380bed30.png";